import * as React from 'react';

import type { Sort, Attributes } from 'stores/PaginationTypes';
import type { EventProceduresEntityType } from 'security-app/hooks/api/eventProceduresAPI.types';

import RowActionMenu from './row-action-menu';

export const EVENT_PROCEDURES_LIST_ID = 'eventProceduresList';

export const ATTRIBUTES: Attributes = [
  {
    id: 'title',
    title: 'Title',
    type: 'STRING',
    sortable: true,
  },
  {
    id: 'description',
    title: 'Description',
    type: 'STRING',
  },
];

export const listElements = {
  defaultLayout: {
    entityTableId: EVENT_PROCEDURES_LIST_ID,
    defaultPageSize: 20,
    defaultSort: { attributeId: 'title', direction: 'asc' } as Sort,
    defaultDisplayedAttributes: ['title', 'description'],
  },
  columnOrder: ['title', 'description'],
};

export const deserializeEventProcedures = ({ page, per_page, total, count, event_procedures }) => ({
  attributes: ATTRIBUTES,
  list: event_procedures,
  pagination: { total, page, per_page, count },
});

export const entityActionRender = (procedure: EventProceduresEntityType) => (
  <RowActionMenu eventProcedure={procedure} />
);
